// Trigger Attentive Popup w/Attentive attribute ID on Click
let attentiveOnClick = document.querySelectorAll(".utility-bar[data-attentive]");
attentiveOnClick.forEach(triggerAttentivePopup);

// Trigger Attentive Popup 
function triggerAttentivePopup(banner) {
  banner.style.cssText += 'cursor: pointer;';
  let attentiveID_Mobile = banner.getAttribute("data-attentive-mobile");
  let attentiveID_Desktop = banner.getAttribute("data-attentive-desktop");
  if (window.innerWidth < 901) {
    banner.addEventListener("click", () => {
      // console.log('Mobile Attentive ID: ' + attentiveID_Mobile); 
      window.__attentive.trigger(null, null, null, attentiveID_Mobile);
    });
  } else {
    banner.addEventListener("click", () => {
      // console.log('Desktop Attentive ID: ' + attentiveID_Desktop);
      window.__attentive.trigger(null, null, null, attentiveID_Desktop);
    });
  }
}